import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const FileImageIcon: React.FC<IconProps> = props => (
  <Icon viewBox="0 0 16 16" {...props}>
    <rect width="16" height="16" rx="4" fill="#D8347C" />
    <path d="M2 13H14L10 8L7 11.75L5 9.25L2 13Z" fill="white" />
    <circle cx="5.5" cy="5.5" r="1.5" fill="white" />
  </Icon>
)
